document.addEventListener('DOMContentLoaded', function() {
    var targets = document.querySelectorAll('.nav-sticky__target');
    
    targets.forEach(function(target){
        // check is target visible
        if (target.getBoundingClientRect().top === 0 && target.getBoundingClientRect().y === 0 && target.getBoundingClientRect().width === 0 && target.getBoundingClientRect().height === 0) return;
        checkElementPosition(target)
    })
    baindNavClick()
    bindNavSelect()
    bindShopNow()
    var navWrapper = document.querySelector('.nav-sticky__wrapper');
    var navContent = document.querySelector('.nav-sticky__content');
    var placeholder = document.querySelector('.nav-sticky__placeholder');
    var offset = 10; // offset to top
    placeholder.style.height = `${navContent.offsetHeight}px`;
  
    window.addEventListener('scroll', function() {
        targets.forEach(function(target){
            checkElementPosition(target)
        })
      var scrollTop = window.scrollY || document.documentElement.scrollTop;
      var navTop = navWrapper.getBoundingClientRect().top + scrollTop;
      if (scrollTop > navTop - offset) {
        navContent.classList.add('fixed');
      } else {
        navContent.classList.remove('fixed');
      }
    });
});
function checkElementPosition(targetElement) {
    if (!targetElement) return;
    var navLinks = document.querySelectorAll('.nav-sticky__wrapper .nav-sticky__item');
    
    var viewportHeight = window.innerHeight;
    var elementRect = targetElement.getBoundingClientRect();
    var elementTop = elementRect.top;
    var elementBottom = elementRect.bottom;
    var elementHeight = elementRect.height
    if (elementRect.top === 0 && elementRect.y === 0 && elementRect.width === 0 && elementRect.height === 0) return;
    const topInRange = elementTop > viewportHeight * 0.2 && elementTop < viewportHeight * 0.5;
    const bottomInRange = Math.abs(elementBottom) > viewportHeight * 0.5;

    var navLink = document.querySelector(`.nav-sticky__wrapper #nav-${targetElement.dataset.target}`);

    if (topInRange || (elementTop <= 0 && elementTop + elementHeight > 0  && bottomInRange)) {
        navLinks.forEach(navLink => {
            navLink.classList.remove('active');
        });
        // console.log('Element elementRect',targetElement.dataset.target, elementRect);
        navLink.classList.add('active')
    }
}

function scrollToElement(targetElement) {
    const viewportHeight = window.innerHeight;
    const offset = viewportHeight * 0.25;
    const elementTop = targetElement.getBoundingClientRect().top + window.scrollY;
    const scrollToPosition = elementTop - offset;
  
    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth'
    });
}

function baindNavClick () {
    var navLinks = document.querySelectorAll('.nav-sticky__wrapper .nav-sticky__item');
    navLinks.forEach(navLink => {
        navLink.addEventListener('click', function(event) {
            event.preventDefault();
            var targetId = this.getAttribute('id').replace('nav-', '');
            var targetElements = document.querySelectorAll(`[data-target=${targetId}]`);
            for (var i = 0; i < targetElements.length; i++) {
                var elementRect = targetElements[i].getBoundingClientRect();
                // check targetElements[i] is visible
                !(elementRect.top === 0 && elementRect.y === 0 && elementRect.width === 0 && elementRect.height === 0) 
                    && scrollToElement(targetElements[i])
            }
        });
    });
}

function bindNavSelect() {
    var select = document.querySelector('.nav-sticky__item-mobile select');
    select.addEventListener('change', function(event) {
        console.log(event.target);
        var target = event.target.value
        var targetElements = document.querySelectorAll(`[data-target=${target}]`);
        for (var i = 0; i < targetElements.length; i++) {
            var elementRect = targetElements[i].getBoundingClientRect();
            // check targetElements[i] is visible
            !(elementRect.top === 0 && elementRect.y === 0 && elementRect.width === 0 && elementRect.height === 0) 
                && scrollToElement(targetElements[i])
        }
    });
}

function bindShopNow() {
    var shopNow = document.querySelector('.nav-sticky__action button');
    shopNow.addEventListener('click', function() {
        var targetElement = document.querySelector('.t4s-product__info-container form [type=submit][name=add]');
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
}